import services from "@/http";
import * as types from "./mutation-types";

export const ActionGetAll = async ({ commit }, payload) => {
  try {
    const { data } = await services.pedidos.get_all(payload);
    commit(types.SET_PEDIDOS, data.data?.data || []);
    commit(types.SET_PAGINATION, data.data || {});
    commit(types.SET_ERROR, {});
    return data;
  } catch (error) {
    commit(types.SET_ERROR, error);
    throw error;
  }
};

export const ActionFind = async (store, payload) => {
  let response = { data: [], meta: {} };

  await services.pedidos.get_all(payload).then((res) => {
    response = res.data;
  });

  return response;
};

export const ActionShow = async ({ commit }, id) => {
  try {
    const { data } = await services.pedidos.show({ id });
    commit(types.SET_PEDIDO, data.pedido || data.data || data);
    commit(types.SET_ERROR, {});
    return data;
  } catch (error) {
    commit(types.SET_ERROR, error);
    throw error;
  }
};

export const ActionSetPedidos = ({ commit }, payload) => {
  commit(types.SET_PEDIDOS, payload);
};

export const ActionSetPedido = ({ commit }, payload) => {
  commit(types.SET_PEDIDO, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};
